import React from 'react';
import { ShieldCheckIcon, AlarmClockIcon } from 'lucide-react';
export function Guarantee() {
  return <section id="guarantee" className="w-full bg-forest-50 py-16 lg:py-20" data-id="element-93" data-mp="1o4exyguev08v">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 lg:grid-cols-[1.15fr_0.85fr]" data-id="element-94" data-mp="223eppxd7zv99">
        <div className="rounded-lg border border-forest-100 bg-white p-8" data-id="element-95" data-mp="22126zhzn1gv5">
          <span className="flex h-12 w-12 items-center justify-center rounded-md bg-forest-800" data-id="element-96" data-mp="1x54p378q82g9">
            <ShieldCheckIcon className="h-6 w-6 text-ember-500" aria-hidden="true" data-id="element-97" data-mp="19f0ol8qu4ith" />
          </span>
          <h2 className="mt-5 font-display text-2xl uppercase text-forest-800 sm:text-3xl" data-id="element-98" data-mp="14hh8e3aktvyw">
            We stand behind our work
          </h2>
          <p className="mt-3 text-lg leading-relaxed text-ink-700" data-id="element-99" data-mp="1edbx9g5e8na4">
            If you&apos;re not 100% satisfied with the job, we make it right. That&apos;s the
            Javier&apos;s Junk Removal promise — no corporate fine print, no excuses, just honest
            local service.
          </p>
        </div>

        <div className="rounded-lg bg-forest-800 p-8" data-id="element-100" data-mp="p0b7vx1bzcgh">
          <span className="flex h-12 w-12 items-center justify-center rounded-md bg-ember-500" data-id="element-101" data-mp="oxp0pyicqyys">
            <AlarmClockIcon className="h-6 w-6 text-ink-900" aria-hidden="true" data-id="element-102" data-mp="tw9r767sy4a1" />
          </span>
          <h2 className="mt-5 font-display text-2xl uppercase text-white sm:text-3xl" data-id="element-103" data-mp="yrp2bqefdm2r">
            Don&apos;t let that pile sit one more day
          </h2>
          <p className="mt-3 text-lg leading-relaxed text-white/80" data-id="element-104" data-mp="61p6eh1wjjc1">
            Every day you wait, it gets worse. Every day you think about it, it&apos;s stress you
            don&apos;t need.
          </p>
        </div>
      </div>
    </section>;
}